import formatTenantLink from '@lib/utils/formatTenantLink';

export const customerLinkToMonolith = (tenantId: string, customerId: string) =>
  formatTenantLink(tenantId, `#/customer/${customerId}`);
export const customerLinkToMonolithSearch = (tenantId: string) =>
  formatTenantLink(tenantId, '#/Search');
export const locationLinkToMonolith = (tenantId: string, locationId: string) =>
  formatTenantLink(tenantId, `#/location/${locationId}`);
export const jobBookingLinkToMonolith = (tenantId: string, jobId: string) =>
  formatTenantLink(tenantId, `#/Job/Index/${jobId}`);
/*
 * Capital-I `#/Invoice/` is the monolith's registered client route
 * (`desktop-legacy/src/Scripts/App/Invoice.js`: `app.get('#/Invoice/:id')`), not a
 * stylistic choice — the legacy router matches case-sensitively, so `#/invoice/`
 * does not resolve. Same convention as `#/Job/Index/` above.
 */
export const invoiceLinkToMonolith = (tenantId: string, invoiceId: string) =>
  formatTenantLink(tenantId, `#/Invoice/${invoiceId}`);
/*
 * Capital-C `#/ChatCenter/` is the monolith's registered Sammy route — same
 * case-sensitive lesson as `#/Invoice/` above. contactNumber is already
 * PhoneNumber.Normalize (NANP bare national; AU/GB keep the trunk 0). Do not
 * re-parse or strip a leading 0.
 */
export const chatCenterLinkToMonolith = (
  tenantId: string,
  contactNumber: string,
) =>
  formatTenantLink(
    tenantId,
    `#/ChatCenter/${encodeURIComponent(contactNumber)}`,
  );
export const bookJobLinkToMonolith = (tenantId: string) =>
  formatTenantLink(tenantId, '#/Calls');
export const dashboardLinkToMonolith = (tenantId: string) =>
  formatTenantLink(tenantId, '#/Dashboard');
export const callContinuityLinkToMonolith = (tenantId: string) =>
  formatTenantLink(tenantId, '#/Settings/CallContinuity');
export const phoneNumbersLinkToMonolith = (tenantId: string) =>
  formatTenantLink(tenantId, '#/Settings/phoneNumbers');

// format from number from +17172012010 to (717)+201-2010
export function formatCallerNumberForCallBubbleDetect(from: string): string {
  const match = RegExp(/\+1(\d{3})(\d{3})(\d{4})/).exec(from);
  if (!match) {
    return from;
  }
  return `(${match[1]})+${match[2]}-${match[3]}`;
}
